import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { OxboAuthProvider, type OxboAuthProviderProps } from "@oxbo/auth-client/react";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { authClient } from "./auth/authClient";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");

// SDK packaging quirk: @oxbo/auth-client/react bundles its own declaration of
// OxboAuthClient (separate private members → nominally incompatible with the one
// from the main entry). Structurally identical, so cast via the provider's own
// prop type. Minor SDK tech-debt — flagged to the auth team.
const providerClient = authClient as unknown as OxboAuthProviderProps["client"];

createRoot(rootEl).render(
  <StrictMode>
    {/* OxboAuthProvider powers the SDK's feature-flag hooks (useFeature / FeatureGate). */}
    <OxboAuthProvider client={providerClient}>
      <AuthProvider client={authClient}>
        {/* Opt into react-router v7 behavior early (silences future-flag warnings). */}
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <App />
        </BrowserRouter>
      </AuthProvider>
    </OxboAuthProvider>
  </StrictMode>,
);
